import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./index.css";
import Register from "./pages/Register";
import Login from "./pages/Login";
import Home from "./pages/Home";
import Navbar from "./components/Navbar";
import ProfilePage from "./pages/ProfilePage";
import AddFriends from "./components/AddFriends";
import FollowListPage from "./pages/FollowListPage";

const App = () => {
  return (
    <>
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/profile/:id" element={<ProfilePage />} />
          <Route path="/profile/:id/followers" element={<FollowListPage type="followers" />} />
          <Route path="/profile/:id/following" element={<FollowListPage type="following" />} />
          <Route path="/users" element={<AddFriends />} />
        </Routes>
      </Router>
    </>
  );
};

export default App;
